export const FETCH_SEASONS_REQUEST = 'FETCH_SEASONS_REQUEST';
export const FETCH_SEASONS_SUCCESS = 'FETCH_SEASONS_SUCCESS';
export const FETCH_SEASONS_FAILURE = 'FETCH_SEASONS_FAILURE';
export const CHECK_SEASONS = 'CHECK_SEASONS';